$(document).ready(function() {

    $('.js-homepage-desktop-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        dots: true,
        arrows: false,
        draggable: false,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    dots: false,
                    fade: true,
                }
            }
        ]
    });

    $('.js-homepage-mobile-slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        dots: false,
        arrows: false,
        draggable: false,
        fade: true
    });

    // $(document).on('click', '.mobile-dots img:not(.disabled)',function() {
    //     let index = $(this).data('slide');
    //
    //     let current_dot_src = $('.js-homepage-mobile-slider .slick-current').data('dot-image');
    //     let current_index = $('.js-homepage-mobile-slider .slick-current').data('slick-index');
    //
    //     $(this).attr('src', current_dot_src).data('slide', current_index);
    //     $('.js-homepage-mobile-slider').slick('slickGoTo', index);
    //
    //     // disable button for 1 second
    //     $('.mobile-dots img').addClass('disabled');
    //     setTimeout(() => {
    //         $('.mobile-dots img').removeClass('disabled');
    //     }, 700);
    //
    // });

    $(document).ready(function(){

        var map_zoom = 1.5;

        $('.js-enlarge-map').click(function(){

            let max_zoom = 2.5;
            if(map_zoom > max_zoom){
                return;
            }

            map_zoom += 0.5;
            $('.hp-map').css('transform', 'scale(' + map_zoom + ')');
        });

        $('.js-shrink-map').click(function(){
            let min_zoom = 1;

            if(map_zoom <= min_zoom){
                return;
            }
            map_zoom -= 0.5;
            $('.hp-map').css('transform', 'scale('+ map_zoom +')');
        });

        // Dragovanie
        var dragging = false;
        var startX, startY, currentX = 0, currentY = 0;
        var map = $('.js-hp-map');

        map.mousedown(function (e) {
            dragging = true;
            startX = e.pageX - currentX;
            startY = e.pageY - currentY;
            map.css('cursor', 'grabbing');
            console.log('mousedown');
        });

        // Zabránime predvolenému ťahaniu obrázka
        map.on('dragstart', function (e) {
            e.preventDefault();
        });

        map.mouseup(function () {
            dragging = false;
            map.css('cursor', 'grab');
            console.log('mouseup');
        });

        map.mousemove(function (e) {
            if (dragging) {
                currentX = e.pageX - startX;
                currentY = e.pageY - startY;
                map.css({
                    top: currentY + 'px',
                    left: currentX + 'px'
                });
            }
        });
    })


})
